import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SelectHotelError = ({ error, onRetry, onLogout }) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50 flex items-center justify-center p-2 sm:p-4">
      <div className="w-full max-w-md text-center">
        <div className="bg-white/80 backdrop-blur-sm border border-slate-200/50 rounded-2xl shadow-xl p-4 sm:p-6 lg:p-8">
          <div className="w-10 h-10 sm:w-12 sm:h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="AlertCircle" size={20} color="var(--color-destructive)" className="sm:hidden" />
            <Icon name="AlertCircle" size={24} color="var(--color-destructive)" className="hidden sm:block" />
          </div>
          <h2 className="text-lg sm:text-xl font-semibold text-slate-900 mb-2">Erro</h2>
          <p className="text-slate-600 mb-4 sm:mb-6 text-sm sm:text-base">{error}</p>
          <div className="space-y-2 sm:space-y-3">
            <Button
              onClick={onRetry}
              variant="default"
              fullWidth
              iconName="RefreshCw"
              iconPosition="left"
            >
              Tentar Novamente
            </Button>
            <Button
              onClick={onLogout}
              variant="outline"
              fullWidth
              iconName="LogOut"
              iconPosition="left"
            >
              Fazer Logout
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectHotelError;
